import { render, staticRenderFns } from "./ReviewEdit.vue?vue&type=template&id=ff55525e"
import script from "./ReviewEdit.vue?vue&type=script&lang=js"
export * from "./ReviewEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports